import Resource from 'App/babel/resources/ResourceTyped';
import type { Widget } from 'App/components/hooks/integrations/externalIntegrationTypes';

class ExternalIntegrationWidgetResource extends Resource<Widget> {
	constructor() {
		super('master/externalintegrationwidgets', undefined, {
			notificationTitle: 'default.widget'
		});
	}

	async findByType(type: string): Promise<Widget[]> {
		const response = await (this as any)._getRequest(`type/${type}`, {
			methodName: 'findByType'
		});
		return response.data;
	}
}

export default new ExternalIntegrationWidgetResource();
